var _style, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoLoadingAnim(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1133.86 1133.86",
    style: {
      enableBackground: "new 0 0 1133.86 1133.86"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.86;}\n\t.st2{opacity:0.15;}\n\t.st3{opacity:0.51;}\n\t.st4{opacity:0.81;}\n\t.st5{opacity:0.7;}\n\t.st6{opacity:0.82;}\n\t.st7{opacity:0.25;}\n\t.st8{opacity:0.14;}\n\t.st9{opacity:0.74;}\n\t.st10{opacity:0.18;}\n\t.st11{opacity:0.66;}\n\t.st12{opacity:0.15;fill:#FFFFFF;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "st0",
    width: 1133.86,
    height: 1133.86
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation1",
    attributeName: "opacity",
    from: 0.86,
    to: 0.5,
    dur: "1s",
    begin: "0s;animation2.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation2",
    attributeName: "opacity",
    from: 0.5,
    to: 0.86,
    dur: "1s",
    begin: "animation1.end"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 283.46,
    y: 0,
    className: "st2",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation12",
    attributeName: "opacity",
    from: 0.15,
    to: 0.4,
    dur: "0.75s",
    begin: "0s;animation22.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation22",
    attributeName: "opacity",
    from: 0.4,
    to: 0.15,
    dur: "0.75s",
    begin: "animation12.end"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 566.93,
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation13",
    attributeName: "opacity",
    from: 1,
    to: 0.65,
    dur: "0.85s",
    begin: "0s;animation23.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation23",
    attributeName: "opacity",
    from: 0.65,
    to: 1,
    dur: "0.85s",
    begin: "animation13.end"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 850.39,
    className: "st3",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation14",
    attributeName: "opacity",
    from: 0.51,
    to: 0.25,
    dur: "0.60s",
    begin: "0s;animation24.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation24",
    attributeName: "opacity",
    from: 0.25,
    to: 0.51,
    dur: "0.60s",
    begin: "animation14.end"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 283.46,
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation15",
    attributeName: "opacity",
    from: 1,
    to: 0.66,
    dur: "0.65s",
    begin: "0s;animation25.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation25",
    attributeName: "opacity",
    from: 0.66,
    to: 1,
    dur: "0.65s",
    begin: "animation15.end"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 283.46,
    y: 283.46,
    className: "st4",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation16",
    attributeName: "opacity",
    from: 0.81,
    to: 0.55,
    dur: "1s",
    begin: "0s;animation26.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation25",
    attributeName: "opacity",
    from: 0.55,
    to: 0.81,
    dur: "1s",
    begin: "animation16.end"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 566.93,
    y: 283.46,
    className: "st5",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation17",
    attributeName: "opacity",
    from: 0.7,
    to: 0.44,
    dur: "0.75s",
    begin: "0s;animation27.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation27",
    attributeName: "opacity",
    from: 0.44,
    to: 0.7,
    dur: "0.75s",
    begin: "animation17.end"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 850.39,
    y: 283.46,
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation18",
    attributeName: "opacity",
    from: 1,
    to: 0.55,
    dur: "0.7s",
    begin: "0s;animation28.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation28",
    attributeName: "opacity",
    from: 0.55,
    to: 1,
    dur: "0.7s",
    begin: "animation18.end"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 850.39,
    className: "st6",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation19",
    attributeName: "opacity",
    from: 0.82,
    to: 0.4,
    dur: "0.85s",
    begin: "0s;animation29.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation29",
    attributeName: "opacity",
    from: 0.4,
    to: 0.82,
    dur: "0.85s",
    begin: "animation19.end"
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 283.46,
    y: 850.39,
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation110",
    attributeName: "opacity",
    from: 1,
    to: 0.73,
    dur: "0.85s",
    begin: "0s;animation210.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation210",
    attributeName: "opacity",
    from: 0.73,
    to: 1,
    dur: "0.85s",
    begin: "animation110.end"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 566.93,
    y: 850.39,
    className: "st7",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation111",
    attributeName: "opacity",
    from: 0.25,
    to: 0.65,
    dur: "0.65s",
    begin: "0s;animation211.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation211",
    attributeName: "opacity",
    from: 0.65,
    to: 0.25,
    dur: "0.65s",
    begin: "animation111.end"
  }))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 850.39,
    y: 850.39,
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation112",
    attributeName: "opacity",
    from: 1,
    to: 0.45,
    dur: "1s",
    begin: "0s;animation212.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation212",
    attributeName: "opacity",
    from: 0.45,
    to: 1,
    dur: "1s",
    begin: "animation112.end"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 566.93,
    className: "st8",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation113",
    attributeName: "opacity",
    from: 0.14,
    to: 0.45,
    dur: "0.68s",
    begin: "0s;animation213.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation213",
    attributeName: "opacity",
    from: 0.45,
    to: 0.14,
    dur: "0.68s",
    begin: "animation113.end"
  }))), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 283.46,
    y: 566.93,
    className: "st9",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation114",
    attributeName: "opacity",
    from: 0.74,
    to: 0.57,
    dur: "0.6s",
    begin: "0s;animation214.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation214",
    attributeName: "opacity",
    from: 0.57,
    to: 0.74,
    dur: "0.6s",
    begin: "animation114.end"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 566.93,
    y: 566.93,
    className: "st10",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation115",
    attributeName: "opacity",
    from: 0.18,
    to: 0.45,
    dur: "0.9s",
    begin: "0s;animation215.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation215",
    attributeName: "opacity",
    from: 0.45,
    to: 0.18,
    dur: "0.9s",
    begin: "animation115.end"
  }))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 850.39,
    y: 566.93,
    className: "st11",
    width: 283.46,
    height: 283.46
  }, /*#__PURE__*/React.createElement("animate", {
    id: "animation116",
    attributeName: "opacity",
    from: 1,
    to: 0.75,
    dur: "0.85s",
    begin: "0s;animation214.end"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "animation216",
    attributeName: "opacity",
    from: 0.75,
    to: 1,
    dur: "0.85s",
    begin: "animation114.end"
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st12",
    width: 1133.86,
    height: 1133.86
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLoadingAnim);
export default __webpack_public_path__ + "static/media/logo-loading-anim.7e296f1ba67010a51d25d5264746129a.svg";
export { ForwardRef as ReactComponent };